<template>
    <v-dialog v-model="openModal" max-width="450" content-class="confirm-delete-dialog">
        <v-card>
            <div class="header">
                <h3>{{ title || ($page.props.lang.confirmModalTitle || 'Confirmation') }}</h3>
                <v-btn @click="$emit('close')" icon><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <!-- <p class="description">{{ description || '' }}</p> -->
            <p v-html="description || ''" class="description">{{ description || '' }}</p>
            <div class="buttons">
                <v-btn color="primary" text @click="$emit('no')">{{ noText || ($page.props.lang.no || 'No') }}</v-btn>
                <v-btn color="primary" text @click="$emit('yes')">{{ yesText || ($page.props.lang.yes || 'Yes') }}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmModal",
    props: {
        open: Boolean,
        title: String,
        description: String,
        noText: String,
        yesText: String
    },
    computed: {
        openModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    }
}
</script>
